{
  "el": {
    "inspiration": {
      "actions": {
        "delete": "Αφαίρεση",
        "deleteMultipleInspirations": "Διαγραφή...",
        "delete_cancel": "Αναίρεση διαγραφής",
        "goBackToInspirationLists": "Εμπνεύσεις",
        "new": "Προσθήκη φωτογραφίας"
      },
      "labels": {
        "move_to_upload": "Βάλε τις φωτογραφίες στο πλαίσιο παρακάτω ή κάνε κλικ για ανέβασμα.",
        "noInspirations": "Δεν υπάρχουν ακόμη εμπνεύσεις",
        "upload_autoclose": "Αυτό το παράθυρο θα κλείσει αυτόματα μόλις ανέβουν όλες οι φωτογραφίες."
      },
      "toasts": {
        "upload_success": "Ανέβηκε {count} έμπνευση | Ανέβηκαν {count} εμπνεύσεις"
      }
    }
  }
}
